import { useAppDispatch, useAppSelector } from '@/redux/hooks'
import { openCommandPalette, closeCommandPalette, setCommandPaletteQuery } from '@/redux/slices/uiSlice'

export function useCommandPalette() {
  const dispatch = useAppDispatch()
  const { isOpen, query, initialAction } = useAppSelector((state) => state.ui.commandPalette)

  return {
    isOpen,
    query,
    initialAction,
    // No payload: uiSlice's openCommandPalette reducer accepts none, so an
    // `initialAction` option here would be silently discarded (the palette
    // reads `initialAction` straight from store state below).
    open: () => dispatch(openCommandPalette()),
    close: () => dispatch(closeCommandPalette()),
    toggle: () => {
      if (isOpen) {
        dispatch(closeCommandPalette())
      } else {
        dispatch(openCommandPalette())
      }
    },
    setQuery: (q: string) => dispatch(setCommandPaletteQuery(q))
  }
}
